import Image from "next/image";
import React from "react";

const ContactInfo = ({ image, styles, dataFooter }) => {
  return (
    <div className="flex items-center gap-2">
      <Image src={image} alt="customer" width={40} height={40} />
      <div className="flex flex-col">
        <div className={`${styles} text-sm font-medium leading-normal`}>
          {dataFooter?.telefon}
        </div>
        <div
          className={`${styles} text-xs font-medium text-opacity-50 leading-normal`}
        >
          {dataFooter?.email}
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
